import _find from 'lodash/find';
import {
  KoRichTextEditorReadOnly,
  KoDateFormatter,
  KoForm,
  KoFormBuilder,
  KoLoader,
  KoNano,
  KoText,
  KoDivider,
  KoChecklist,
  KoEmpty,
  KoModal,
  KoButton,
  KoRichTextEditor,
  Select,
  KoSelect
} from 'packages';
import KoIcon from '@kwapio/icons';

import { Link } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useParams } from 'react-router';
import { PRIORITY } from 'shared/commonConstants';
import { DevelopmentAPI} from 'pages/workspace/process/development/development.service';
import { getCookie } from 'shared/utils/cookies';
// import {  Sprint } from './components';
import styles from './curd.module.scss';

function TestCaseCrud({ className, ticketId, form, isOpen, caseId,setModal, setCurrentRecord, handleFinish, initialValues, subtask , epic, epicId}) {
  const {workspaceId} = useParams();
  const userById      = useSelector(state => state?.userById);
  const [activityTypes, setActivityTypes] = useState(undefined);

  const [isLoading, setLoading] = useState(false);
  const [lookupId, setLookupId] = useState();
  const [issueDetails, setIssueDetails] = useState();
  const [isPassOpen,setIsPassOpen] = useState(false);
  const [isFailOpen,setIsFailOpen] = useState(false);
  const [statusData,setStatusData] = useState();
  const StatusWatch = KoForm.useWatch('status', form);
  let userDetails = userById['data'];
  // const ticketId = KoForm.useWatch('ticketId', form);

  useEffect(()=>{
    if(ticketId){
      getIssueById(ticketId);
    }
  },[ticketId]);
  
  useEffect(() => {
    if (!initialValues || Object.keys(initialValues).length === 0) {
      form?.resetFields();
      form?.setFieldsValue({ status: 1, type: 'positive', priority: 3 });
    } else {
      form?.setFieldsValue(initialValues);
    }
    if (workspaceId) {
      setActivityTypes(undefined);
      DevelopmentAPI.getActivityTypes(workspaceId).then(
        (data) => {
          setActivityTypes(data?.activities || []);
        },
        () => {
          setActivityTypes([]);
        }
      );
    }
  }, [workspaceId, initialValues, form]);

  useEffect(() => {
    if (epic) {
      form.setFieldsValue({ issueType: 1 ,  reporter: userDetails && userDetails?.userId});
    }
  }, [epic]);

  const getIssueById = (ticketId, workspaceIdFromParam)=> {
    setLoading(true);
    DevelopmentAPI.getIssueByIdReadonly(ticketId, workspaceId || workspaceIdFromParam).then(
      (data) => {
        setLoading(false);
        setIssueDetails(data?.issue);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (issueDetails?.lookupId) {
      setLookupId(issueDetails.lookupId);
    } else {
      const lp = KoNano('LOK');
      setLookupId(lp);
      let data = form?.getFieldsValue() || {};
      data['lookupId'] = lp;
      form?.setFieldsValue({ ...data });
    }

  }, []);


  const handleSubmit = useCallback(values => {
    handleFinish(values);
  });

  const statusOptions = [
    { label: "Not Executed", value: 1, color: "#8c8c8c" },
    { label: "Partially Executed", value: 2, color: "#faad14" },
    { label: "Passed", value: 3, color: "#52c41a" },
    { label: "Failed", value: 4, color: "#ff4d4f" },
    { label: "Blocked", value: 5, color: "#722ed1" }
  ];

  const TaskStatus = ({ value, onChange }) => (
    <Select
      value={value}
      onChange={onChange}
      options={statusOptions.map((item) => ({
        value: item.value,
        label: (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: item.color,
                display: "inline-block"
              }}
            />
            {item.label}
          </div>
        )
      }))}
    />
  );


  const TypeOptions = [

    { label: "Positive", value: 'positive', color: "#52c41a" },
    { label: "Negative", value: 'negative', color: "#ff4d4f" }
  ];

  const TypesOptions = ({ value, onChange }) => (
    <Select
      value={value}
      onChange={onChange}
      options={TypeOptions.map((item) => ({
        value: item.value,
        label: (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: item.color,
                display: "inline-block"
              }}
            />
            {item.label}
          </div>
        )
      }))}
    />
  );



  const handleFinishFailed = (mode) =>{
    if(mode === "pass"){
      var updData = {
        status:StatusWatch,
        tickectClose:true,
        ticketId:ticketId
      };
      setLoading(true);
      DevelopmentAPI.updateTicketCreationStatus(updData, caseId, workspaceId).then(
        (data) => {
          setLoading(false);
          setIsPassOpen(false);
          setStatusData(data);
        },
        (err) => {
          setLoading(false);
        }
      );
    }else if(mode === "fail"){
      updData = {
        status:StatusWatch,
        ticketCreation:true,
        ticketId:ticketId
      };
      setLoading(true);
      DevelopmentAPI.updateTicketCreationStatus(updData, caseId, workspaceId).then(
        (data) => {
          setLoading(false);
          // setIsFailOpen(false);
          setStatusData(data);
        },
        (err) => {
          setLoading(false);
        }
      );
    }
  };

  const issueType    = _find(activityTypes, function(o) { return o.value === issueDetails?.issueType; }) || {};
  const ticketStatus = _find(issueDetails?.workflow, function(o) { return o.value === issueDetails?.status; }) || {};
  const priority     = _find(PRIORITY, function(o) { return o.value === issueDetails?.priority; }) || {};
  const ISSUE_DETAILS = () =>{
    return(
      <div className={styles.summarySection}>
        <div className={styles.summaryRow}>
          <div className={styles.summary}>
            <KoText className={styles.label} text={'Issue Type'} />
            <div className={styles.issueType}>
              <div className={styles.TicketIdWrapper} aria-label={issueType?.label}>
                <KoIcon name={issueType.icon} />
                <KoText className={styles.text} text={`${issueType?.label}`} />
              </div>
            </div>
          </div>
          <div className={styles.summary}>
            <KoText className={styles.label} text={'Ticket Status'} />
            <div className={styles.issueType} style={{padding: '.1rem .8rem', color: ticketStatus?.color, borderColor: ticketStatus?.color, background: ticketStatus?.background }}>
              <KoText text={ticketStatus?.label} style={{color: ticketStatus?.color}} />
            </div>
          </div>
          <div className={styles.summary}>
            <KoText className={styles.label} text={'Sprint'} />
            <div className={styles.issueType}>
              <KoText text={issueDetails?.sprintName} />
            </div>
          </div>
          <div className={styles.summary}>
            <KoText className={styles.label} text={'Epic'} />
            <div className={styles.issueType}>
              {issueDetails?.epic ?  <div className={styles.TicketIdWrapper} aria-label={issueDetails?.epic}>
                <KoIcon name={issueType.icon} />
                <KoText className={styles.text} text={`${issueDetails?.epic}`} />
              </div> : <KoText text={'-'} />}
            </div>
          </div>
          <div className={styles.summary}>
            <KoText className={styles.label} text={'Priority'} />
            <div className={styles.issueType}>
              <KoText text={priority?.label} />
            </div>
          </div>
          <div className={styles.summary}>
            <KoText className={styles.label} text={'Story Points / Estimate'} />
            <div className={styles.issueType}>
              <KoText text={issueDetails?.storyPoints || "-"} />
            </div>
          </div>
        </div>
        <KoText className={styles.label} text={'Description'} />
        <div className={styles.summaryRow}>
          <div className={styles.summary}>
            <KoRichTextEditorReadOnly text='-' initialValues={issueDetails?.description} />
          </div>
        </div>
        <KoText className={styles.label} text={'Acceptance Criteria'} />
        <div className={styles.summaryRow}>
          <div className={styles.summary}>
            <KoRichTextEditorReadOnly text='-' initialValues={issueDetails?.acceptanceCriteria} />
          </div>
        </div>
      </div>
    );
  };

  const Prerequisites = ({ value, onChange }) =>
    <KoChecklist value={value} initialValue={value} workspaceId={workspaceId}
      form={form} name='prerequisite' lookupId={lookupId}
      onChange={v => onChange(v)}
    />;

  const stepsReproduce = ({ value, onChange }) =>
    <KoChecklist value={value} initialValue={value} lookupId={lookupId} workspaceId={workspaceId}
      form={form} name='expectedResult'
      placeholder='Add a description...'
      onChange={v => onChange(v)}
    />;
  const enabledButtons = {
    color: true,
    backgroundColor: true,
    alignLeft: true,
    alignCenter: true,
    alignRight: true,
    alignJustify: true,
    blockquote: true,
    codeBlock: true,
    link: true,
    insertEmbed: true
  };

  const Description = ({ value, onChange }) =>
    <KoRichTextEditor enabledButtons={enabledButtons} lookupId={lookupId} workspaceId={workspaceId} initialValues={value} onSetEditorValues={v => onChange(v)}/>;

      
  const TestData = ({ value, onChange }) =>
    <KoRichTextEditor enabledButtons={enabledButtons} lookupId={lookupId} workspaceId={workspaceId} initialValues={value} onSetEditorValues={v => onChange(v)}/>;


  const ExpectedResult = ({ value, onChange }) =>
    <KoChecklist value={value} initialValue={value} lookupId={lookupId} workspaceId={workspaceId}
      form={form} name='expectedResult'
      placeholder='Add a description...'
      onChange={v => onChange(v)}
    />;

  const ActualResult = ({ value, onChange }) =>
    <KoChecklist value={value} initialValue={value} lookupId={lookupId} workspaceId={workspaceId}
      form={form} name='actualResult'
      placeholder='Add a description...'
      onChange={v => onChange(v)}
    />;

  const Priority = ({ value, onChange }) =>
    <KoSelect value={value}
      showSearch
      defaultValue={3}
      onChange={v => onChange(v)}
      placeholder='Select priority'
      options={PRIORITY}
      optionRender={(option) => (
        <div className={styles.priorityWrapper}>
          <span>{option.data.label}</span>
        </div>
      )}
    />;

  const TC_META = {
    columns: 6,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'status', label: 'Status', colSpan: 2,
        widget: TaskStatus, forwardRef: true
      },
      {
        key: 'type', label: 'Case Type', colSpan: 2,
        widget: TypesOptions, forwardRef: true
      },
      {
        key: 'priority', label: 'Priority', colSpan: 2,
        widget: Priority,
        forwardRef: true
      },
      {
        key: 'prerequisite', label: 'Prerequisites', placeholder: 'List of prerequisites', colSpan: 6,
        widget: Prerequisites
      },
      {
        key: 'testData', label: 'Test Data', placeholder: 'Input data for test case', colSpan: 6,
        widget: TestData
      },
      {
        key: 'expectedResult', label: 'Expected Result', placeholder: 'Expected outcome of the test', colSpan: 3,
        widget: ExpectedResult
      },
      {
        key: 'actualResult', label: 'Actual Result', placeholder: 'What happened when the test was executed', colSpan: 3,
        widget: ActualResult
      },
      {
        key: 'description', label: 'Description', placeholder: 'Test case description', colSpan: 6,
        widget: Description
      },
      {
        key: 'stepsReproduce', label: 'Steps Reproduce', colSpan: 6,
        widget: stepsReproduce, forwardRef: true
      }
    ]
  };

  return (
    <KoModal
      title={`${initialValues?.caseId ? 'Update' : 'Create'} Test Case`}
      centered
      open={isOpen}
      afterClose={() => {setCurrentRecord();}}
      handleOk={() => { setCurrentRecord(); setModal(false); }}
      onClose={() => { setCurrentRecord(); setModal(false); }}
      width={'95vw'}
      maskClosable={false}
      footer={[
        <KoButton key='cancel' label='Cancel' onClick={() => setModal(false)} />,
        <KoButton key='create' loading={isLoading} type='primary' label={initialValues?.caseId ? `Update` : `Create`}
          onClick={() => form.submit()} />
      ]}
    >
      <div className={`${styles.ticketWrapper} 'tabContnetTicket'`}>
        {isLoading && <KoLoader/>}
        <div className={`${styles.wrapper} ${className ? className : ''}`}>
          <KoForm form={form} layout="vertical"
            onFinish={handleSubmit} onSubmit={handleSubmit}>
            <div className={styles.leftForm}>
              <div className={`${ticketId && issueDetails ? 'formHeader' : ''}`}>
                <div className={styles.TicketIdWrapper} aria-label={issueType?.label}>
                  <KoIcon name={issueType.icon} />
                  <KoText className={styles.text} text={`${issueType?.label} ${ticketId ? `#${ticketId}` : ''}`} />
                </div>
                {ticketId && issueDetails?.createdAt ?
                  <div className={styles.createdAtWrapper}>
                    <KoText text="Created on"  className={styles.createdAtText}/>
                    <KoDateFormatter className={styles.createdAtDate} data={issueDetails?.createdAt} format="DD-MMM-YYYY" />
                  </div>
                  : null
                }
              </div>
              {ticketId ?
                <>
                  <KoDivider orientation="left" orientationMargin={0} >
                    <KoText className={styles.labelSubText} text="ISSUE DETAILS" />
                  </KoDivider>
                  <ISSUE_DETAILS />
                 
                 
                </>
                : null
              }
            
            </div>
            <div className={styles.rightForm}>
              {ticketId ?
                <KoFormBuilder form={form} meta={TC_META} on/> :
                <div className={styles.emptyForm}>
                  <KoEmpty title='Create new test case' subText='Select a Ticket to Write a Test Case or View Test Case Results' icon='EmptyTwoTone' />
                </div>}
            </div>
          </KoForm>
        </div>
        <KoModal
          title={`Test Case Passed - ${ticketId}`}
          centered
          open={isPassOpen}
          handleOk={() => {setIsPassOpen(false); }}
          onClose={() => {setIsPassOpen(false); }}
          width={580}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setIsPassOpen(false)} />,
            <KoButton key='reset' loading={isLoading} type='primary' label='Close Ticket' onClick={() => handleFinishFailed("pass")} />
          ]}
        >
          {isLoading && <KoLoader circle={false} />}
          <div className={styles.suspend}>
            <KoText text={`The test case has passed. Do you want to close the ticket?`} />
          </div>
        </KoModal>
        <KoModal
          title={`Test Case Failed - ${ticketId}`}
          centered
          open={isFailOpen}
          handleOk={() => {setIsFailOpen(false); }}
          onClose={() => {setIsFailOpen(false); }}
          width={580}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setIsFailOpen(false)} />,
            <KoButton key='reset' loading={isLoading} type='primary' label='Create Ticket' onClick={() => handleFinishFailed("fail")} />
          ]}
        >
          {isLoading && <KoLoader circle={false} />}
          <div className={styles.suspend}>
            <KoText text={`The test case has failed. Do you want to create a ticket?`} />
            {statusData?.ticketId ?
              <div className={styles.ticketInfo}>
                <Link target="_blank" to={`/open/ticket/${getCookie("accountId")}/${workspaceId}/${statusData?.ticketId}`}>
                  <div className={styles.ticketText}>
                  Ticket ID:
                    <div className={styles.ticketId}>{statusData?.ticketId}.</div>
                  Do you want to open it?
                  </div>
                </Link>
              </div>
              :null
            }
          </div>
        </KoModal>
      </div>
    </KoModal>
  );
};

export default TestCaseCrud;